import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var regionRedirectEndpointMiddleware = function regionRedirectEndpointMiddleware(config) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var originalRegion, regionProviderRef, unlock, result, region;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return config.region();
              case 2:
                originalRegion = _context2.sent;
                regionProviderRef = config.region;
                unlock = function unlock() {};
                if (context.__s3RegionRedirect) {
                  Object.defineProperty(config, "region", {
                    writable: false,
                    value: function () {
                      var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                return _context.abrupt("return", context.__s3RegionRedirect);
                              case 1:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));
                      function value() {
                        return _value.apply(this, arguments);
                      }
                      return value;
                    }()
                  });
                  unlock = function unlock() {
                    return Object.defineProperty(config, "region", {
                      writable: true,
                      value: regionProviderRef
                    });
                  };
                }
                _context2.prev = 6;
                _context2.next = 9;
                return next(args);
              case 9:
                result = _context2.sent;
                if (!context.__s3RegionRedirect) {
                  _context2.next = 17;
                  break;
                }
                unlock();
                _context2.next = 14;
                return config.region();
              case 14:
                region = _context2.sent;
                if (!(originalRegion !== region)) {
                  _context2.next = 17;
                  break;
                }
                throw new Error("Region was not restored following S3 region redirect.");
              case 17:
                return _context2.abrupt("return", result);
              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](6);
                unlock();
                throw _context2.t0;
              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 20]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
export var regionRedirectEndpointMiddlewareOptions = {
  tags: ["REGION_REDIRECT", "S3"],
  name: "regionRedirectEndpointMiddleware",
  override: true,
  relation: "before",
  toMiddleware: "endpointV2Middleware"
};